"use client";

import { c as _c } from "react/compiler-runtime";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { useUserLocation } from "@/hooks/use-user-location";
import { useMap } from "@vis.gl/react-google-maps";
import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

/**
 * Automatically centers the map on the user's location if:
 * 1. Permission is granted
 * 2. Location is available
 * 3. User hasn't selected a specific location/project
 * 4. We haven't auto-centered yet (run once)
 * 5. The URL did not initially have a 'center' parameter (meaning user landed on default city view)
 */
export function AutoCenterUser() {
  const $ = _c(9);
  const map = useMap();
  const {
    userLocation,
    permissionStatus
  } = useUserLocation();
  const {
    filters
  } = useUrlFilters();
  const searchParams = useSearchParams();
  const hasCenteredRef = useRef(false);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.has("center") ?? false;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const initialCenterParamRef = useRef(t0);
  let t1;
  let t2;
  if ($[2] !== filters.locations || $[3] !== filters.selectedLocationId || $[4] !== map || $[5] !== permissionStatus || $[6] !== userLocation) {
    t1 = () => {
      if (map && !hasCenteredRef.current && permissionStatus === "granted" && userLocation && !filters.selectedLocationId && (!filters.locations || filters.locations.length === 0) && !initialCenterParamRef.current) {
        map.panTo(userLocation);
        map.setZoom(14);
        hasCenteredRef.current = true;
      }
    };
    t2 = [map, userLocation, permissionStatus, filters.selectedLocationId, filters.locations];
    $[2] = filters.locations;
    $[3] = filters.selectedLocationId;
    $[4] = map;
    $[5] = permissionStatus;
    $[6] = userLocation;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
  return null;
}